export default function WhatIsATrail() {
  return (
    <section className="py-20 px-6 bg-light-warm relative z-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl text-dark-teal mb-6">
            What Is a Trail?
          </h2>
        </div>

        <div className="bg-white rounded-boggler p-8 md:p-12 shadow-boggler">
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-primary-text font-lato leading-relaxed mb-6">
              A <strong className="text-boggler-teal">trail</strong> is a personalized content compilation from your guide — 
              recorded on their phone, addressed <em>specifically to you</em>, and delivered to your TV.
            </p>
            
            <p className="text-xl text-primary-text font-lato leading-relaxed mb-6">
              It's not a broadcast. It's not a YouTube video for the masses. It's your guide thinking about you, 
              curating or adding content specifcally for you, and talking to <strong>you</strong> — about your journey, your questions, and your growth.
            </p>

            <p className="text-xl text-primary-text font-lato leading-relaxed mb-6">
              Imagine settling into your couch, turning on TV, and seeing a new trail waiting. 
              You press play. Your guide's trail appears, speaking directly to you: <em>"Hey Frodo, I was thinking 
              about what we talked about last week... Here's a screenshare of my threads feed and this user is talking about what we talked about!"</em>
            </p>

            <p className="text-xl text-primary-text font-lato leading-relaxed">
              That's a trail. Personal guidance, delivered with intention, watched with presence.
            </p>
          </div>

          <div className="mt-10 grid md:grid-cols-3 gap-6 text-center">
            <div className="p-4 bg-warm-cream rounded-boggler">
              <div className="text-3xl mb-2">📱</div>
              <p className="font-montserrat font-semibold text-heading-dark">Guide records</p>
              <p className="text-sm text-muted-text font-lato">Video journal on iPhone</p>
            </div>
            <div className="p-4 bg-warm-cream rounded-boggler">
              <div className="text-3xl mb-2">👤</div>
              <p className="font-montserrat font-semibold text-heading-dark">Addressed to you</p>
              <p className="text-sm text-muted-text font-lato">Your name, your situation</p>
            </div>
            <div className="p-4 bg-warm-cream rounded-boggler">
              <div className="text-3xl mb-2">📺</div>
              <p className="font-montserrat font-semibold text-heading-dark">Watch on TV</p>
              <p className="text-sm text-muted-text font-lato">Lean back, follow the trails</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
